<template>
    <rkm-overlay :show="loading">
        <rkm-form
            class="login-form"
            ref="RkmForm"
        >
            <h1>Troca de senha</h1>
            <h5>Por favor informe uma nova senha de acesso</h5>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nova_senha"
                        class="password"
                        name="Nova senha"
                        placeholder="Nova senha"
                        v-model="model.nova_senha"
                        vid="nova_senha"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon icon="lock" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nova_senha_confirmation"
                        class="password"
                        name="Confirmar nova senha"
                        placeholder="Confirmar nova senha"
                        v-model="model.nova_senha_confirmation"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon icon="lock" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <div class="login-form-actions">
                        <rkm-row>
                            <rkm-col>
                                <rkm-button
                                    @click="handleTrocarSenha"
                                    block
                                    color="primary"
                                    type="submit"
                                >
                                    Trocar senha
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-link @click="handleLogout">
                                    Sair do sistema
                                </rkm-link>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-overlay>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('autenticacao-trocar-senha-form')
        },
        validations() {
            return {
                nova_senha: {
                    required: true,
                    min: 8,
                    max: 12,
                    senha: true,
                },
                nova_senha_confirmation: {
                    required: true,
                    min: 8,
                    max: 12,
                    senha: true,
                    confirmed: 'nova_senha',
                },
            }
        },
    },
    data: () => ({
        model: {
            nova_senha: null,
            nova_senha_confirmation: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'clearLocalStorage',
            'setLoading',
            'unsetLoading',
        ]),
        handleLogout() {
            this.repositories.autenticacao.logout()
                .then(() => {
                    this.clearLocalStorage()
                        .then(cliente => {
                            this.$router.push({name: 'login', params: {cliente: cliente.link}})
                        })
                })
                .catch(this.handleError)
        },
        handleTrocarSenha() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('autenticacao-trocar-senha-form')

                        this.repositories.perfil.update(this.model)
                            .then(() => {
                                this.showSuccessNotification(null, 'Senha alterada com sucesso.')

                                this.clearLocalStorage()
                                    .then((cliente) => {
                                        this.$router.push({name: 'login', params: {cliente: cliente.link}})
                                    })
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('autenticacao-trocar-senha-form'))
                    }
                })
        },
    },
    mixins: [error, notification],
}
</script>

<style scoped>
.password >>> input {
    -webkit-text-security: disc;
}
</style>